export const getBestPriceByAirlinesStyles = (theme, isCustomSearch) => ({
  containerSx: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: '#FFFFFF',
    marginBottom: isCustomSearch ? '-1vh' : '1vh',
    padding: {
      xs: '21px 41px',
      sm: 'initial',
    },
    borderRadius: {
      xs: '8px',
      sm: isCustomSearch ? '8px' : '8px 8px 0px 0px',
    },
    mb: {
      xs: 0,
      sm: isCustomSearch ? '-1vh' : '1vh',
    },
  },

  cardsContainerSx: {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: '1rem',
    textAlign: 'center',
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
  },

  bestPriceAirCardSx: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    height: '100%',
    cursor: 'pointer',
    borderBottom: '6px solid #ffff',
    '&:hover': {
      borderBottom: `6px solid ${theme.primary}`,
      '.bestPriceAirCardName': { fontWeight: 700 },
      '.bestPriceAirCardPrice': { fontWeight: 400 },
    },
    maxWidth: {
      xs: '200px',
      sm: 'initial',
    },
    mb: {
      xs: '1rem',
      sm: 0,
    },
  },

  moreOptionsSx: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    color: theme.tertiary,
    '&:hover': {
      fontWeight: 700,
    },
  },
});
